export const months = [
    "January", "February", "March", 
    "April", "May", "June", 
    "July", "August", "September", 
    "October", "November", "December"
]

export const convert12HourFormat = (time : string) => {
    const [hour, minute] = time.trim().split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return minute === 0
        ? `${hour12}${period}`
        : `${hour12}:${minute.toString().padStart(2, "0")}${period}`;
}